<script setup lang="ts">
  import { computed } from 'vue';

  import { Badge } from '@ui/components/badge';
  import type { BadgeVariants } from '@ui/components/badge';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';
  import { cn } from '@ui/utils/utils';

  interface Props {
    direction: 'outbound' | 'inbound';
    size?: BadgeVariants['size'];
    withLabel?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), { size: 'sm' });

  const label = computed(() => (props.direction === 'outbound' ? 'Outbound' : 'Received'));
</script>

<template>
  <Tooltip :disabled="withLabel" :delay-duration="400">
    <TooltipTrigger as-child>
      <Badge
        variant="outline"
        :size
        tabindex="-1"
        :class="
          cn(
            'text-center items-center flex flex-row justify-center gap-2',
            !withLabel && 'size-5',
            {
              'text-primary border-primary/20 bg-primary/5': direction === 'inbound',
              'text-success border-success/20 bg-success/5': direction === 'outbound',
            },
          )
        "
      >
        <i
          :class="
            cn(
              'fas',
              size === 'xs' && 'text-3xs!',
              direction === 'outbound' ? ' fa-arrow-up-right' : ' fa-arrow-down-left',
            )
          "
        />

        <span v-if="withLabel"> {{ label }} </span>
      </Badge>
    </TooltipTrigger>

    <TooltipContent>
      {{ label }}
    </TooltipContent>
  </Tooltip>
</template>

<style scoped></style>
